// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3OP6m","rootSuccess":"CompleteLink_rootSuccess__2p3fM","rootFailure":"CompleteLink_rootFailure__3paOv","isDisabled":"CompleteLink_isDisabled__3tdPK"};